/* Peachy's Premium v2 — JS */
document.addEventListener('DOMContentLoaded', () => {

  // Sticky header
  const header = document.querySelector('.site-header');
  if (header) window.addEventListener('scroll', () => header.classList.toggle('scrolled', window.scrollY > 48));

  // Scroll reveal
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); } });
  }, { threshold: 0.10 });
  document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

  // FAQ accordion
  document.querySelectorAll('.faq-q').forEach(q => {
    q.addEventListener('click', () => {
      const item = q.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  // Smooth scroll
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const hash = a.getAttribute('href');
      if (!hash || hash === '#' || hash.length < 2) return;
      const target = document.querySelector(hash);
      if (target) {
        // El ancla existe en esta página → scroll suave
        e.preventDefault();
        window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
      } else {
        // El ancla no está en esta página (ej. estás en "Quiénes somos") → ir al home + ancla
        e.preventDefault();
        window.location.href = '/' + hash;
      }
    });
  });

  // Al llegar a una página con #ancla en la URL (ej. /#packs desde otra sección),
  // scrollear con el offset del header fijo.
  if (window.location.hash && window.location.hash.length > 1) {
    const onLoadTarget = document.querySelector(window.location.hash);
    if (onLoadTarget) {
      setTimeout(() => {
        window.scrollTo({ top: onLoadTarget.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
      }, 350);
    }
  }

});
